export default __webpack_public_path__ + "static/media/balkan-flag.86fc17b2.svg";